import React from 'react'
import * as rn from 'react-native'

interface Props {
  readonly children?: React.ReactNode
  readonly colors: readonly string[]
  readonly style?: rn.StyleProp<rn.ViewStyle>
}

export default function LinearGradient({
  children,
  colors,
  style,
}: Props): React.ReactElement {
  return (
    <rn.View
      style={[
        style,
        {
          background: `linear-gradient(to bottom, ${colors.join(', ')})`,
        } as rn.ViewStyle,
      ]}
    >
      {children}
    </rn.View>
  )
}
